var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.titleName)?_c('div',{staticClass:"has-text-weight-bold has-text-centered"},[_vm._v(" "+_vm._s(_vm.titleName)+" ")]):_vm._e(),_vm._t("childrendisplay",function(){return _vm._l((_vm.children),function(child){return _c('b-button',{key:child.id,attrs:{"expanded":""},on:{"click":function($event){return _vm.$router.push({
          name: 'administration:view-' + _vm.name,
          params: { id: child.id },
        })}}},[_vm._v(" "+_vm._s(child.name)+" ")])})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }